<template>
  <b-input
      :value="innerValue"
      maxlength="250"
      v-cleave="mask"
  />
</template>

<script>
export default {
  name: 'ModernEmailInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      innerValue: this.value,
      mask: {
        blocks: [250],
        lowercase: true,
        onValueChanged: this.onValueChange,
      },
    };
  },
  methods: {
    onValueChange(event) {
      const value = event.target.rawValue;
      this.$emit('input', (value || '').toLowerCase());
    },
  },
  watch: {
    value(value) {
      this.innerValue = value;
    },
  },
};
</script>
